import SamplingSpecClass from '../db/SamplingSpecClass';

export function update_parameters(this: SamplingSpecClass, params: Record<keyof SamplingSpecClass, any>) {
  for (const [prop, val] of Object.entries(params)) {
    this[prop] = val;
  }
}
